(() => {
  const navigate = (event, button) => {
    if (!button?.dataset.gsQuoteUrl) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const url = new URL(button.dataset.gsQuoteUrl, location.origin);
    const quantity = button.form?.querySelector('[name="quantity"]')?.value || '1';
    url.searchParams.set('quantity', quantity);
    location.assign(url.href);
  };
  document.addEventListener('click', event => {
    navigate(event, event.target.closest('button[data-gs-quote-url]'));
  }, true);
  document.addEventListener('submit', event => {
    navigate(event, event.submitter || event.target.querySelector('button[data-gs-quote-url]'));
  }, true);
})();
